import { Invoice } from '../../../../type/entities/invoice-type';

export type RectificationAction = 'minor_regeneration' | 'full_credit_note' | 'partial_credit_note' | 'major_replacement';

export const rectificationActionRequiresAmount = (action: RectificationAction): boolean => {
    return action === 'partial_credit_note' || action === 'major_replacement';
};

export const rectificationActionRequiresPreview = (action: RectificationAction): boolean => {
    return action === 'full_credit_note' || action === 'partial_credit_note' || action === 'major_replacement';
};

export const getCreditNotePreviewAmount = (action: RectificationAction, amount: number | null): number | null => {
    return rectificationActionRequiresAmount(action) ? amount : null;
};

export const buildReplacementDataFromInvoice = (invoice: Invoice | null | undefined, replacementTotalPrice?: number | null) => ({
    invoiceDate: invoice?.invoiceDate?.date?.split(' ')[0],
    paymentDate: invoice?.paymentDate?.date?.split(' ')[0],
    expirationDate: invoice?.expirationDate?.date?.split(' ')[0],
    tax: invoice?.tax,
    replacementTotalPrice,
    lines: invoice?.lines?.map((line) => ({
        concept: line.concept,
        amount: line.amount,
        tax: line.tax,
        units: line.units,
        totalWithoutTax: line.totalWithoutTax,
        totalWithTax: line.totalWithTax,
        contract: line.contract?.id ?? null,
    })) ?? [],
});
